// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2lSMi","title":"Info_title__3hVZQ","selects":"Info_selects__QJQ3f","requiredAsterisk":"Info_requiredAsterisk__UJeFP"};